// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filterRow {
    border-bottom: 1px solid;
    margin: 20px;
}

    .filterRow table {
        width: 100%;
    }

    .filterRow th {
        text-align: left;
    }

.filterdeleteButton {
    width: 60px;
    align-items: flex-end;
    align-self: center;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/objectcreator/filter/filterpanel.control.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,YAAY;AAChB;;IAEI;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;AAEJ;IACI,WAAW;IACX,qBAAqB;IACrB,kBAAkB;AACtB","sourcesContent":[".filterRow {\n    border-bottom: 1px solid;\n    margin: 20px;\n}\n\n    .filterRow table {\n        width: 100%;\n    }\n\n    .filterRow th {\n        text-align: left;\n    }\n\n.filterdeleteButton {\n    width: 60px;\n    align-items: flex-end;\n    align-self: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
